var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('section',[_c('div',{staticClass:"o-grid o-grid--no-gutter"},[_vm._m(1),_c('div',{staticClass:"o-grid__cell top-buttons"},[_c('bos-button',{on:{"click":_vm.newTaskDefinition}},[_vm._v("Neuer Prozess-Schritt")])],1)]),_c('bos-overview-table',{attrs:{"data":_vm.taskDefinitions,"columns":[
        {
          key: 'displayNameDe',
          name: 'Name'
        },
        {
          key: 'serviceGroup',
          name: 'Leistungsgruppe'
        }
      ],"deleteTitle":"Prozess-Schritt löschen","deleteText":obj =>
          'Soll der Prozess-Schritt <b>"' +
          obj.displayNameDe +
          '"</b> wirklich gelöscht werden?',"onEdit":_vm.editTaskDefinition,"onDelete":_vm.deleteTaskDefinition,"disableDelete":obj => obj.isUsed}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v("Stammdaten bearbeiten")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-grid__cell"},[_c('h4',[_vm._v("Prozess-Schritte")])])
}]

export { render, staticRenderFns }